export default __webpack_public_path__ + "static/media/btn-pin-round-off-30.c4e3e129.svg";